import React, { useState, useEffect } from "react";
import "./careteam.css";
import axios from "axios";
import Moment from "react-moment";
import { Fragment } from "react";
import { MdArrowRight } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  combineDateTime,
  convertToTimeZone,
  formatDate,
  getFullName,
  getMondayDate,
  getMonthAgoDate,
  sendDateFormat,
} from "../../utils/CommonFunctions";
import { sortByDateDescend } from "../../Apis/commonApis";
import { currentCareSiteId } from "../../redux-toolkit/reducer/switchSites";
import { useSelector } from "react-redux";
import JournalDetailFacility from "./JournalDetailFacility";
import JournalDetailAgency from "./JournalDetailAgency";

const CareTeamJournalAsApp = (props) => {
  const monthAgoDate = getMonthAgoDate();
  const { careteamId } = props;

  const { currentCareSiteData } = useSelector(
    (state) => state.caresiteDataReducer
  );

  const [journalData, setJournalData] = useState([]);
  const [careteamJournal, setcareteamJournal] = useState({});
  const [loading, setLoading] = useState(false);

  const [filterType, setFilterType] = useState("custom");
  const [dateRange, setDateRange] = useState([monthAgoDate, new Date()]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (currentCareSiteData) {
      if (filterType === "custom" && endDate) {
        getJournalbyClientId(formatDate(startDate), formatDate(endDate));
      } else if (filterType === "week") {
        const mondayDate = getMondayDate(new Date());
        getJournalbyClientId(formatDate(mondayDate), formatDate(new Date()));
      } else if (filterType === "today") {
        const sendDate = formatDate(new Date());
        getJournalbyClientId(sendDate, sendDate);
      }
    }
  }, [filterType, dateRange, currentCareSiteData]);

  const getJournalbyClientId = (start, end) => {
    setLoading(true);
    axios({
      url: `${process.env.REACT_APP_BASEURL}/CareMemberJournal?careTeamId=${careteamId}&careHomeId=${currentCareSiteId}&startDate=${start}&endDate=${end}`,
      method: "GET",
      headers: { Authorization: localStorage.getItem("care_admin_token") },
    })
      .then((res) => {
        setLoading(false);
        let resData = res?.data;
        if (resData.status) {
          // if (currentCareSiteData?.carefacility === "facalities") {
          //   handleFacilityData(resData);
          // } else if (currentCareSiteData?.carefacility === "agency") {
          // }
          handleAgencyData(resData);
        } else {
          setJournalData([]);
          setcareteamJournal({});
        }
      })
      .catch((error) => console.log(`Error: ${error}`));
  };

  function handleAgencyData(allData) {
    const shiftData = allData?.result;
    const taskData = allData?.tasks;
    const taskCountData = allData?.taskCount?.totalTask;
    let careteamJournals = [];
    shiftData?.forEach((shift) => {
      const forClientName = shift?.forClient ?? getFullName(shift?.clientId);
      const shiftTasks = taskData.filter(
        (item) => item.shiftDate?.split("T")[0] === shift.Date
      );
      const taskCompleted = shiftTasks?.filter(
        (task) =>
          (task?.status === "omitted" || task?.status === "true") &&
          task.shiftId === shift.shiftId
      );
      const totalTaskObj = taskCountData.find(
        (item) => item.date === shift.Date
      );
      const fandfRating = shift?.fanfRatings?.reduce(
        (acc, curr) => acc + curr.rating,
        0
      );
      const avgRating =
        shift?.fanfRatings?.length > 0
          ? fandfRating / shift?.fanfRatings?.length
          : 0;
      careteamJournals.push({
        shiftId: shift?.shiftId,
        _id: shift?._id,
        totalTask: totalTaskObj?.count ?? shiftTasks?.length,
        completedTasks: taskCompleted?.length,
        Date: shift?.Date ?? "",
        shiftDateTime: combineDateTime(
          shift.Date,
          shift.startingTime,
          shift.timeZone
        ),
        endDate: shift?.endDate ?? shift?.endDate,
        Task: shiftTasks,
        notesData: shift.notesData,
        forClient: forClientName,
        startingTime: shift?.startingTime ?? "",
        endingTime: shift?.endingTime ?? "",
        shiftTimeZone: shift.timeZone,
        careTeam: shift?.careTeamId,
        checkinDateTime: shift?.checkinDateTime,
        checkoutDateTime: shift?.checkoutDateTime,
        fndfRating: Math.ceil(avgRating),
        clientId: shift?.clientId?.[0],
        shiftApprovalstatus: shift?.shiftApprovalstatus ?? "",
        shiftEndDatetime: shift?.shiftEndDatetime ?? "",
        status: shift?.status ?? shift?.status,
        templateType: shift?.templateType ?? "",
        wellbeingAssessment: shift?.wellbeingAssessment ?? {},
      });
    });

    if (careteamJournals?.length > 0) {
      let sortedObj = sortByDateDescend(careteamJournals, "shiftDateTime");
      let groupdate = groupJournalDataByDate(sortedObj);
      // let groupdate = groupItems(sortedObj, "Date");
      // groupdate = Object.entries(groupdate).map(([k, v]) => ({ [k]: v }));
      setJournalData(groupdate);
      setcareteamJournal(sortedObj[0]);
    } else {
      setJournalData([]);
      setcareteamJournal({});
    }
  }

  const calendarStrings = {
    lastDay: "[Yesterday ]",
    sameDay: "[Today ]",
    nextDay: "[Tomorrow ]",
    lastWeek: "L",
    nextWeek: "L",
    sameElse: "L",
  };

  function customDateChangeHandler(daterange) {
    setDateRange(daterange);
    // if()
    // Example usage:
    // if (daterange[1]) {
    //   const startDate = new Date(daterange[0]);
    //   const endDate = new Date(daterange[1]);
    //   const datesInRange = getDatesInRange(startDate, endDate);
    //   const filteredData = journalAllData.filter((date) =>
    //     datesInRange.includes(Object.keys(date)[0])
    //   );
    //   setJournalData(filteredData);
    // } else if (!daterange[0] && !daterange[1]) {
    //   setJournalData(journalAllData);
    // }
  }

  function completedTasks(journalData) {
    const tasks = [...journalData?.Task, journalData?.wellbeingAssessment];
    const completed = tasks?.filter(
      (item) => item?.status === "true" && item.shiftId === journalData._id
    );
    return [
      completed?.length > 0 ? completed?.length : 0,
      tasks?.length > 0 ? tasks?.length : 0,
    ];
  }

  const activeTab = {
    background: "#f0e8f7",
  };

  return (
    <>
      <div className="row clientList">
        <div className="col-md-6 shiftsHistory">
          <h5 style={{ color: "#9B51E0" }}>Shifts History</h5>
          <ul className="filter_box me-2 mb-1">
            <button
              exact
              className={filterType === "today" ? "active" : ""}
              onClick={() => setFilterType("today")}
            >
              Today
            </button>
            <button
              className={filterType === "week" ? "active " : ""}
              onClick={() => setFilterType("week")}
            >
              This Week
            </button>
            <button
              className={filterType === "custom" ? "active" : ""}
              onClick={() => setFilterType("custom")}
            >
              Custom
            </button>
            {filterType === "custom" ? (
              <div className="datepicker_input">
                <DatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    customDateChangeHandler(update);
                  }}
                  isClearable={true}
                />
              </div>
            ) : (
              <div className="container">&ensp;</div>
            )}
          </ul>
        </div>
        <div className="col-md-6"></div>
        <div className="col-md-6 journalListScroll">
          <ul className="menuList">
            {loading && <p>Loading...</p>}
            {journalData.length > 0 &&
              journalData?.map((journal, jIndex) => {
                // const date = Object.keys(journal);
                // const datewisejournal = Object.values(journal).flatMap(
                //   (num) => num
                // );
                return (
                  <Fragment key={jIndex}>
                    <h5 className="titlen">
                      <span style={{ color: "#BB6BD9" }}>
                        <Moment calendar={calendarStrings}>
                          {journal.date}
                        </Moment>
                      </span>{" "}
                      <br />
                      <Moment format="Do MMM YYYY">{journal.date}</Moment>
                    </h5>
                    {journal?.shifts?.map((item, index) => {
                      return (
                        <li
                          style={
                            item._id === careteamJournal._id ? activeTab : {}
                          }
                          key={index}
                          onClick={() => {
                            setcareteamJournal(item);
                          }}
                        >
                          <a>
                            {/* <img alt="" src={item?.clientId[0]?.image} /> */}
                            <div className="body">
                              <p style={{ color: "#BB6BD9" }}>
                                {item?.startingTime} - {item?.endingTime}
                              </p>
                              <h5>
                                {/* {`${item?.clientId?.[0]?.first_Name}'s`}  */}
                                Shift Summary
                              </h5>{" "}
                              <MdArrowRight className="arrowIcon" />
                            </div>
                          </a>
                        </li>
                      );
                    })}
                  </Fragment>
                );
              })}
            {loading === false && journalData.length === 0 && (
              <p>No Shift Available</p>
            )}{" "}
          </ul>
        </div>
        {Object.keys(careteamJournal).length !== 0 && (
          <>
            {/* {currentCareSiteData?.carefacility === "facalities" && (
              <JournalDetailFacility careteamJournal={careteamJournal} />
            )}
            {currentCareSiteData?.carefacility === "agency" && (
            )} */}
            <JournalDetailAgency careteamJournal={careteamJournal} />
          </>
        )}
      </div>
    </>
  );
};

export default CareTeamJournalAsApp;

function groupJournalDataByDate(shiftdata) {
  if (shiftdata.length < 1) {
    return [];
  }
  const grouped = {};
  shiftdata?.forEach((item) => {
    const dateLabel = new Date(item.Date).toDateString();

    if (!grouped[dateLabel]) {
      grouped[dateLabel] = [];
    }
    grouped[dateLabel].push(item);
  });

  return Object.keys(grouped).map((date) => ({
    date,
    shifts: grouped[date],
  }));
}

function getTotaCompletedTasks(shift) {
  return shift?.assignedCareTeam?.reduce((acc, obj) => {
    let completeTasksInObject = obj.Task.reduce((count, task) => {
      return (
        count +
        (task.status === "true" &&
        task.shiftId === shift._id &&
        task?.doneBy === obj.careTeamId?._id
          ? 1
          : 0)
      );
    }, 0);
    return acc + completeTasksInObject;
  }, 0);
}
